import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import {
  CONTENTFUL_NEWS_PAGE_SIZE,
  fetchAllNewsItemsPages,
  shouldPaginateNewsItems,
} from '../../utils/contentfulNewsPagination';

export default function newsPagesWithData(WrappedComponent, options = {}) {
  const QUERY = gql`
          query newsPageQuery($newsQuery: String, $newsSkip: Int, $newsLimit: Int) {
            newsItems(q: $newsQuery, skip: $newsSkip, limit: $newsLimit) {
              visibilityValue
              videoLink
              newsTitle
              route
              date
              description
              department {
                visibilityValue
                name
                route
              }
              image {
                title
                description
                url
              }
            }

            _newsItemsMeta(q: $newsQuery) {
              count
            }

            newsPages {
              backgroundHeader
              backgroundDescription
              newsHeader
              backgroundImage {
                title
                description
                url
              }
            }

            feedbackComponents {
              feedbackHeader
              feedbackDescription
              feedbackCtAtext
              feedbackImage {
                title
                description
                url
              }
            }

            headerFooterComponents {
              footerHeader
              footerBody
              copyrightHolder
              primaryNavigationLinks {
                route
                text
              }
              seasonalPrimaryNavigationLinks {
                route
                text
              }
              footerLinks {
                route
                text
              }
              seasonalFooterLinks {
                route
                text
              }
              secondaryFooterLinks {
                route
                text
              }
              footerLogo {
                title
                description
                url
              }
            }

            exploreComponents {
              isNotDisplayed
              exploreTitle
              exploreTile {
                backgroundImage {
                  title
                  description
                  url
                }
                route
                title
                ctaText
              }
            }

            globalSites {
              feedback {
                feedbackHeader
                feedbackDescription
                feedbackCtAtext
                feedbackImage {
                  title
                  description
                  url
                }
              }
              mainNavigation {
                footerHeader
                footerBody
                copyrightHolder
                primaryNavigationLinks {
                  route
                  text
                }
                seasonalPrimaryNavigationLinks {
                  route
                  text
                }
                footerLinks {
                  route
                  text
                }
                seasonalFooterLinks {
                  route
                  text
                }
                secondaryFooterLinks {
                  route
                  text
                }
                footerLogo {
                  title
                  description
                  url
                }
              }
              cubsLogo {
                title
                url
              }
            }
          }
        `;

  const HOC = class extends Component {
    componentDidMount() {
      this.loadRemainingNewsItems();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.newsPageQuery !== this.props.newsPageQuery) {
        this.loadRemainingNewsItems();
      }
    }

    componentWillUnmount() {
      this.unmounted = true;
    }

    async loadRemainingNewsItems() {
      const { newsPageQuery } = this.props;

      if (this.loadingRemainingNews || !shouldPaginateNewsItems(newsPageQuery)) {
        return;
      }

      this.loadingRemainingNews = true;

      try {
        await fetchAllNewsItemsPages(newsPageQuery);
      } catch (error) {
        if (!this.unmounted) {
          console.warn('Unable to fetch all Contentful news items for route-specific newsPageQuery.', error);
        }
      } finally {
        this.loadingRemainingNews = false;
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return graphql(QUERY, {
    name: 'newsPageQuery',
    options: props => ({
      variables: {
        newsQuery: `fields.route=${props.match.params.news}`,
        newsSkip: 0,
        newsLimit: CONTENTFUL_NEWS_PAGE_SIZE,
      },
      notifyOnNetworkStatusChange: true,
    }),
  })(HOC);
}
